import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private _loading = signal(false);

  readonly loading = this._loading.asReadonly();

  hideLoadingIndicator(): void {
    this._loading.set(false);
  }

  showLoadingIndicator(): void {
    this._loading.set(true);
  }
}
